import { v4 as uuidv4 } from 'uuid';
import SocketType from './SocketType';
import ISocketMessageStructure from './ISocketMessageStructure';
import { TEMPLATE_TYPES } from '../../EditorManipulators/types/types';
import { SocketID } from '../../../../features/websocket/model/types/types';

class SocketMessage<TypeBody> {
	private readonly id: SocketID;
	private readonly type: SocketType;
	private readonly body: TypeBody;
	private readonly structure: ISocketMessageStructure<TypeBody>;

	constructor(type: SocketType, body: TypeBody) {
		this.type = type;
		this.body = body;
		this.id = uuidv4();
		this.structure = {
			id: this.id,
			type,
			body,
		};
	}

	public getID = (): string => this.id;
	public getBody = (): TypeBody => this.body;
	public getType = (): SocketType => this.type;
	public getJSON = (): string => JSON.stringify(this.structure);

	public getJSONMessage = (templateType: TEMPLATE_TYPES): string => {
		const message = JSON.stringify({
			id: this.id,
			type: `sketch.${templateType}_template.template.process`,
			body: JSON.stringify(this.body),
		});

		return message;
	};
}

export default SocketMessage;
